<!--我的项目-->

<template>
	<SecondaryPageComponent :type-list="$t('tab.project')" :type-change-event="typeChange">
		<!-- 插槽主体内容 -->
		<div class="collection-table" slot="content-slot">
			<div class="c-t-head">
				<div v-for="item in thead" class="col" :class="item.width + ' ' + item.align">{{item.title}}</div>
			</div>
			<div class="c-t-body">
				<div class="row" v-if="dataList.length <= 0"><span class="none-data">{{$t('vip.available')}}...</span></div>
				<div v-if="dataList.length > 0" class="row" v-for="(outItem,outIndex) in dataList">
					<div v-for="(item,index) in thead" class="col" :class="item.width + ' ' + item.align">
						<!--col 1-->
						<template v-if="index === 0">
							<span class="c-question" :title="outItem.projectNames">
								{{outItem.projectName.length > 10
                ? (outItem.projectName.substring(0,10) + '...')
                : outItem.projectName}}
							</span>
						</template>
						<!--col 2-->
						<template v-if="index === 1">
							<span class="c-question" :title="outItem.phone">
								{{outItem.phone}}
							</span>
						</template>
						<!--col 3-->
						<template v-if="index === 2">
							<span class="c-question remark" :title="outItem.projectDescribe">
								{{ (outItem.projectDescribe.length > 10
                ? (outItem.projectDescribe.substring(0,10) + '...') : outItem.projectDescribe)}}
							</span>
						</template>
						<!--col 4-->
						<template v-if="index === 3">
							<span class="c-status">
								{{outItem.projectState === 0
                ? $t('project.submitted') : outItem.projectState === 1
                ? $t('project.underReview') : outItem.projectState === 2
                ? $t('project.Passed') : $t('project.Rejected')}}
							</span>
						</template>
						<!--col 5-->
						<template v-if="index === 4">
							<div class="btn-col">
								<a @click="cancelBtn(outIndex)" v-if="[1].includes(outItem.projectState)" class="btn" href="javascript:void(0)">{{$t('project.cancel')}}</a>
								<a @click="editBtn(outIndex)" v-if="[0,1].includes(outItem.projectState)" class="btn col-btn-2" href="javascript:void(0)">{{$t('project.edit')}}</a>
								<a @click="submitBtn(outIndex)" v-if="[0].includes(outItem.projectState)" class="btn col-btn-1" href="javascript:void(0)">{{$t('project.Submit')}}</a>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>

		<!-- page 分页 插槽内容 -->
		<div class="page-component" slot="pager-slot">
			<!--发起-->
			<a class="send-tec" @click="sendTec">{{$t('project.add')}}</a>
			<!--pager-->
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
			 :total="totalDataCounts">
			</el-pagination>
		</div>

		<!--模态框-->
		<ModelPop v-if="showModel" slot="model-slot">
			<div class="content-model-box">
				<div class="top-title">
					<span>{{modelType === 1 ? $t('project.newlyadded') : $t('project.edit')}} {{ $t('project.Myproject')}}</span>
					<span class="close-btn" @click="() => showModel = false ">{{$t('project.close')}}</span>
				</div>
				<div class="from-box">
					<div class="from-col">
						<p class="from-title"><span style="color:red;">*</span>{{dataTitleGroup.projectName}}：</p>
						<div style="flex:1;">
							<el-input :placeholder="$t('project.Pleaseenter')" maxlength="50" type="text" v-model="dataGroup.projectName"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span style="color:red;">*</span>{{dataTitleGroup.phone}}：</p>
						<div style="flex:1;">
							<el-input :placeholder="$t('project.Pleaseenter')" maxlength="50" type="text" v-model="dataGroup.phone"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span style="color:red;">*</span>{{dataTitleGroup.projectDescribe}}：</p>
						<div style="flex:1;">
							<el-input type="textarea" :rows="3" maxlength="500" show-word-limit resize="none" :placeholder="$t('project.Pleaseenter')"
							 v-model="dataGroup.projectDescribe"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"></p>
						<el-button type="primary" @click="submitData">{{$t('project.Submit')}}</el-button>
					</div>
				</div>
			</div>
		</ModelPop>
	</SecondaryPageComponent>
</template>

<script>
	import '../../../assets/css/l-table.css';
	import SecondaryPageComponent from '../../assembly/SecondaryPageComponent';
	import ModelPop from '../../assembly/ModelPop';
	export default {
		name: "MyProject",
		components: {
			SecondaryPageComponent,
			ModelPop
		},
		data() {
			return {
				typeList: ['我的项目'],
				thead: [],
				dictCtype: [],
				dataObjLang: {},
				dictTypeLang: [],
				dataList: [],
				currentPage: 1,
				pageSize: 5,
				totalDataCounts: 0,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() <= Date.now();
					}
				},
				editIndex: -1,
				modelType: 1,
				showModel: false,
				dataTitleGroup: {},
				dataGroup: {}
			};
		},
		created() {
			this.token = sessionStorage.getItem("token");
			this.thead = this.$t('project.thead')
			this.dataTitleGroup = this.$t('project.dataTitleGroup')
			this.dataGroup = this.$t('project.dataGroup')
			this.loadData(1);
		},
		methods: {
			sendTec() {
				this.showModel = true;
				this.modelType = 1;
				Object.keys(this.dataGroup).forEach(item => {
					this.dataGroup[item] = "";
				})
			},
			typeChange(index) {

			},
			//当页码改变时
			handleCurrentChange(pageNum) {
				this.loadData(pageNum);
				this.currentPage = pageNum;
			},
			//初始化表格数据
			loadData(pageNum) {
				this.$get('/api/myProject/myProjectList', {
					token: this.token,
					pageSize: this.pageSize,
					pageNum
				}).then(res => {
					let resData = res.data;
					this.dataList = resData;
					this.totalDataCounts = res.params.totalDataCounts;
				})
			},
			//取消按钮
			cancelBtn(index) {
				this.$confirm(this.$t('Tips.projectTips')).then(() => {
					this.$post('api/myProject/abolishMyProject', {
						token: this.token,
						projectId: this.dataList[index].projectId
					}).then(res => {
						if (res.code === 0) {
							this.dataList[index].projectState = 0;
							this.$message({
								type: 'success',
								message: this.$t('Tips.qxsuc')
							})
						}
					})
				}).catch(() => {
					this.$message({
						type: 'error',
						message: this.$t('project.cancelErr')
					})
				});
			},

			submitBtn(index) {
				this.$confirm(this.$t('Tips.SubmitTips')).then(() => {
					this.$post('/api/myProject/submitMyProject', {
						token: this.token,
						projectId: this.dataList[index].projectId
					}).then(res => {
						if (res.code === 0) {
							this.dataList[index].projectState = 1;
							Object.keys(this.dataGroup).forEach(item => {
								this.dataGroup[item] = '';
							})
							this.$message({
								type: 'success',
								message: this.$t('Tips.Submitsue')
							})

						}
					})
				}).catch(() => {
					this.$message({
						type: 'error',
						message: this.$t('project.hasCancel')
					})
				});
			},
			// 编辑按钮
			editBtn(index) {
				this.modelType = 2;
				this.showModel = true;
				this.editIndex = index;
				let editData = this.dataList[index];
				Object.keys(this.dataGroup).forEach(item => {
					this.dataGroup[item] = editData[item] + '';
				});
			},

			checkData() {
				let data = this.dataGroup;
				let phoneNum = /^[1][3,4,5,7,8][0-9]{9}$/;
				if (!phoneNum.test(data.phone)) {
					return false;
				}
				return true
			},
			//提交数据
			submitData() {
				if (!this.checkData()) {
					this.$message({
						type: 'warning',
						message: this.$t('Tips.telWrong')
					}).then(() => {
						return;
					});
				}

				let data = {
					...this.dataGroup,
					token: this.token,
				};
				let url = '/api/myProject/addMyProject';
				if (this.modelType === 2) {
					data.projectId = this.dataList[this.editIndex].projectId;
					url = '/api/myProject/editMyProject';
					this.$put(url, data).then(res => {
						if (res.code === 0) {
							this.showModel = false;
							this.loadData(this.currentPage);
							Object.keys(this.dataGroup).forEach(item => {
								this.dataGroup[item] = '';
							})
							this.$message({
								type: 'success',
								message: this.$t('Tips.xmeditsuc')
							})
						}
					});
					return;
				}

				this.$post(url, data).then(res => {
					if (res.code === 0) {
						this.showModel = false;
						this.loadData(this.currentPage);
						Object.keys(this.dataGroup).forEach(item => {
							this.dataGroup[item] = '';
						});
						this.$message({
							type: 'success',
							message: this.$t('Tips.Submitsue')
						})
					}
				});
			}
		}
	}
</script>
<style scoped>
	.send-tec {
		width: 154px;
		height: 36px;
		display: block;
		background: linear-gradient(0deg, rgba(5, 115, 203, 1) 0%, rgba(63, 159, 234, 1) 100%);
		border-radius: 2px;
		line-height: 36px;
		font-size: 14px;
		color: #fff;
		position: absolute;
		top: calc(50% - 18px);
		left: 20px;
	}

	/*  c-question  */
	.c-question {
		padding: 6px 13px;
		text-align: left;
	}

	.c-status {
		color: #26AFFD;
	}

	/*  */
	.btn.col-btn-2 {
		border: 1px solid #999999;
		color: #999999;
	}

	.btn.col-btn-1 {
		border: 1px solid #001580;
		color: #002480;
	}

	/* model box */
	.content-model-box {
		width: 650px;
		height: 500px;
		background: #FFFFFF;
		box-shadow: 1px 1px 10px 0 rgba(255, 255, 255, 1);
		border-radius: 5px;
		margin-top: 120px;
	}

	.content-model-box>.top-title {
		height: 40px;
		line-height: 40px;
		text-align: left;
		background: rgba(243, 243, 243, 1);
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		padding-left: 20px;
		font-size: 16px;
		position: relative;
	}

	.content-model-box>.top-title>.close-btn {
		position: absolute;
		right: 10px;
		top: 0;
		cursor: pointer;
	}

	.content-model-box>.top-title>.close-btn:hover {
		color: #DF402D;
	}

	.content-model-box>.from-box {
		display: flex;
		flex-direction: column;
		max-height: calc(100% - 40px);
		overflow: auto;
		padding: 0 20px;
	}

	.content-model-box>.from-box>.from-col {
		display: flex;
		justify-content: flex-start;
		margin: 8px 0;
	}

	.content-model-box>.from-box>.from-col>.from-title {
		width: 100px !important;
		text-align: right;
		padding-right: 20px !important;
	}

	.radio-list .el-radio-group {
		justify-content: flex-start;
		flex-wrap: wrap;
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/myProject/MyProject.vue